import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { addMembershipSignupRecord, addPayment, addWishlistItem, addWaitlistItem, addWaitlistBundle, activateTrialToMembership, autoLoginPasswordless, cancelMembership, updatePassword, createAddress, deleteAddress, deleteWishlistItem, facebookLogIn, forceRegistrationDate, forceSkipAllowed, forgotPassword, getIsMemberFromState, getMembershipCancellationReasons, loadBouncebackEndowmentHistory, initiateReturn, loadAddresses, loadCustomerDetails, loadOrders as _loadOrders, loadEmailPreferences, loadForeignMembership, loadLoyaltyDetails, loadLoyaltyPlans, loadLoyaltyRewardPromos, loadMembership, loadMembershipCredits, loadMembershipDetails, loadMembershipPeriod, loadOrderDetails, loadPayments, loadPhoneNumber, loadProfile, loadRetailStores, loadReturnSettings, loadWishlist, loadWishlistIds, loadWaitlist, loadWaitlistIds, logIn, logOut, purchaseMembershipPeriod, resetPassword, setDefaultAddress, signUp, skipMembershipPeriod, snoozeMembership, submitCcpa, tokenizeCreditCard, updateAddress, updateCustomerDetail, updateEmailPreferences, updateMembershipDetail, updateMembershipStatus, updatePayment, updateProfile, verifyPassword, loadReviewableProducts, loadReviewableProductDetails, saveProductReview, saveProductReviewImage, validateAddress, loadShippingLocations, verifyIdmeCustomer, loadMembershipSuggestedProducts, loadHappyReturnBars, loadCopsSegmentTraits } from './accountsModule';
import { invalidateOrderDetails as _invalidateOrderDetails, loadRMADetails as _loadRMADetails, useModuleDispatch, loadLoyaltyHistory as _loadLoyaltyHistory } from './accountsModuleTyped';
export default function useAccountActions() {
  var dispatch = useModuleDispatch();
  var actions = useMemo(function () {
    return _objectSpread(_objectSpread({}, bindActionCreators({
      activateTrialToMembership: activateTrialToMembership,
      addMembershipSignupRecord: addMembershipSignupRecord,
      addPayment: addPayment,
      addWishlistItem: addWishlistItem,
      addWaitlistItem: addWaitlistItem,
      addWaitlistBundle: addWaitlistBundle,
      autoLoginPasswordless: autoLoginPasswordless,
      cancelMembership: cancelMembership,
      updatePassword: updatePassword,
      createAddress: createAddress,
      deleteAddress: deleteAddress,
      deleteWishlistItem: deleteWishlistItem,
      facebookLogIn: facebookLogIn,
      forceRegistrationDate: forceRegistrationDate,
      forceSkipAllowed: forceSkipAllowed,
      forgotPassword: forgotPassword,
      getIsMemberFromState: getIsMemberFromState,
      getMembershipCancellationReasons: getMembershipCancellationReasons,
      loadBouncebackEndowmentHistory: loadBouncebackEndowmentHistory,
      initiateReturn: initiateReturn,
      loadAddresses: loadAddresses,
      loadCustomerDetails: loadCustomerDetails,
      loadEmailPreferences: loadEmailPreferences,
      loadForeignMembership: loadForeignMembership,
      loadLoyaltyDetails: loadLoyaltyDetails,
      loadLoyaltyPlans: loadLoyaltyPlans,
      loadLoyaltyRewardPromos: loadLoyaltyRewardPromos,
      loadMembership: loadMembership,
      loadMembershipCredits: loadMembershipCredits,
      loadMembershipDetails: loadMembershipDetails,
      loadMembershipPeriod: loadMembershipPeriod,
      loadOrderDetails: loadOrderDetails,
      loadPayments: loadPayments,
      loadPhoneNumber: loadPhoneNumber,
      loadProfile: loadProfile,
      loadRetailStores: loadRetailStores,
      loadReturnSettings: loadReturnSettings,
      loadWishlist: loadWishlist,
      loadWishlistIds: loadWishlistIds,
      loadWaitlist: loadWaitlist,
      loadWaitlistIds: loadWaitlistIds,
      logIn: logIn,
      logOut: logOut,
      purchaseMembershipPeriod: purchaseMembershipPeriod,
      resetPassword: resetPassword,
      setDefaultAddress: setDefaultAddress,
      signUp: signUp,
      skipMembershipPeriod: skipMembershipPeriod,
      snoozeMembership: snoozeMembership,
      submitCcpa: submitCcpa,
      tokenizeCreditCard: tokenizeCreditCard,
      updateAddress: updateAddress,
      updateCustomerDetail: updateCustomerDetail,
      updateEmailPreferences: updateEmailPreferences,
      updateMembershipDetail: updateMembershipDetail,
      updateMembershipStatus: updateMembershipStatus,
      updatePayment: updatePayment,
      updateProfile: updateProfile,
      verifyPassword: verifyPassword,
      loadReviewableProducts: loadReviewableProducts,
      loadReviewableProductDetails: loadReviewableProductDetails,
      saveProductReview: saveProductReview,
      saveProductReviewImage: saveProductReviewImage,
      validateAddress: validateAddress,
      loadShippingLocations: loadShippingLocations,
      verifyIdmeCustomer: verifyIdmeCustomer,
      loadMembershipSuggestedProducts: loadMembershipSuggestedProducts,
      loadHappyReturnBars: loadHappyReturnBars,
      loadCopsSegmentTraits: loadCopsSegmentTraits
    }, dispatch)), {}, {
      loadOrders: function loadOrders() {
        return dispatch(_loadOrders.apply(void 0, arguments));
      },
      loadRMADetails: function loadRMADetails() {
        return dispatch(_loadRMADetails.apply(void 0, arguments));
      },
      invalidateOrderDetails: function invalidateOrderDetails() {
        return dispatch(_invalidateOrderDetails.apply(void 0, arguments));
      },
      loadLoyaltyHistory: function loadLoyaltyHistory() {
        return dispatch(_loadLoyaltyHistory.apply(void 0, arguments));
      }
    });
  }, [dispatch]);
  return actions;
}